<template>
    <div>
        <iframe class="Iframe" :src="src"></iframe>
    </div>
</template>
<script>
export default {
    data() {
        return {
            src: ""
        }
    },
    mounted() {
        this.src = this.$route.query.src
    }
}
</script>
<style lang="scss" scoped>
.Iframe{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
}
</style>